/**
 * Каркас главной страницы.
 *
 * Отдельный от общего: на первом экране нет ни навигации по разделам, ни
 * футера — всё, что можно нажать кроме «Играть», уводит от единственного
 * действия, ради которого человек сюда попал. Шапка лежит поверх картинки
 * и не имеет фона: подложка здесь работает на впечатление, и полоса поперёк
 * неё его ломает.
 */
import { useTranslation } from "react-i18next";
import { NavLink, Outlet } from "react-router-dom";

import { LanguageSwitcher } from "./LanguageSwitcher";
import { LogoMark } from "./LogoMark";
import { ThemeSwitcher } from "./ThemeSwitcher";

export function LandingLayout() {
  const { t } = useTranslation();

  return (
    <div className="relative flex h-full min-h-svh flex-col overflow-hidden bg-ink-950">
      <header className="absolute inset-x-0 top-0 z-20 flex h-16 items-center gap-3 px-4 sm:px-8">
        <NavLink to="/" className="flex items-center gap-2.5">
          <LogoMark />
          <span className="font-sans text-xl font-semibold tracking-tight text-ink-50">
            Chrono<span className="text-amber-400">Guessr</span>
          </span>
        </NavLink>

        <div className="ml-auto flex items-center gap-2">
          <ThemeSwitcher />
          <LanguageSwitcher />
          <NavLink to="/login" className="btn-ghost">
            {t("nav.login")}
          </NavLink>
        </div>
      </header>

      <Outlet />
    </div>
  );
}
